// Application configuration constants
export const APP_CONFIG = {
  // Launch date for countdown timer
  launchDate: new Date('2025-12-11T00:00:00'),
  
  // Beta spots configuration
  betaSpots: {
    total: 20,
    initial: 20
  },
  
  // API configuration
  api: {
    timeout: 300000
  }
}

export default APP_CONFIG
